import _ from 'lodash';
import { OddsFormat, BetType, OddsFormatVS, RoundRobinOption } from '../common/Foundation';
import $ from 'jquery';
import Constants from '../common/Constants';
import BetServices from '../services/BetServices';
import memberService from '../services/MemberService';
import CommonUtil from '../common/CommonUtil';

const { THE_1X2, HANDICAP, OU } = BetType;

export default class BetslipAction {

    /**
       * Claculate Max Payout for bet
       * stake: input stake
       * odds: odds 
       * ot: odds type (odds format)
       * wrs: win risk stake (WIN, RISK, BASE)
       * bt: bet type
       * isVS: is Virtual sport
       * isMoneyLine: use for Virtual sport
       * 
       */
    static calculateMaxPay = (stake, odds, ot, bt, wrs, isVS, isMoneyLine) => {
        if (!stake || stake === 0){
            return 0;
        }
        var po = 0;
        var factor = ot === OddsFormat.American ? 100 : 1;
        if (OddsFormat.American === ot || OddsFormatVS.American === ot) {
            if (wrs === 'WIN'){
                if (odds > 0) {
                    po = stake + (stake / odds * 100 );
                } else if (odds < 0) {
                    po = stake + (stake * Math.abs(odds) / 100 );
                }
            } else if (wrs === 'RISK'){
                if (odds > 0) {
                    po = stake + (stake * odds / 100 );
                } else if (odds < 0) {
                    po = stake + (stake / Math.abs(odds) * 100 );
                }
            } else {
                po = (Math.abs(odds)/100 + 1) * stake;
            }
        } else {
            if (isVS){
                if (odds < 0) {
                    let isTrue = OddsFormatVS.Malay === ot || OddsFormatVS.Indonesian === ot;
                    po = isTrue ? (stake * Math.abs(odds) +  stake) : stake * 2;
                } else if (odds < 1) {
                    po = stake * odds + stake;
                } else {
                    if (ot === OddsFormatVS.Decimal || isMoneyLine) {
                        po = stake * odds;
                    } else {
                        po = stake * (odds / factor) + stake;
                    }
                }
            } else if (BetType.THE_1X2 !== bt) {
                if (odds < 0) {
                    let isTrue = OddsFormat.Malay === ot || OddsFormat.Indonesian === ot || 
                    OddsFormatVS.Malay === ot || OddsFormatVS.Indonesian === ot ;
                    po = isTrue ? (stake * Math.abs(odds) +  stake) : stake * 2;
                } else if (odds < 1) {
                    po = stake * odds + stake;
                } else {
                    if (ot === 1) {
                        po = stake * odds;
                    } else {
                        po = stake * (odds / factor) + stake;
                    }
                }
            } else {
                po = stake * Math.abs(odds);
            }
        }
        return po;
    }

    /**
     * calculate Win from stake
     * @param {*} stake 
     * @param {*} odds 
     * @param {*} ot : odds type
     * @param {*} wrs : win risk stake (WIN, RISK, BASE)
     */
    static calculateToWin(stake, odds, ot, wrs){
        let win = 0;
        if (wrs === 'WIN'){
            win = stake;
        } else if (wrs === 'RISK'){
            win = this.calculateToWinFromRisk(stake, odds, ot);
        } else {
            if (odds > 0){
                win = this.calculateToWinFromRisk(stake, odds, ot);
            } else {
                win = stake;
            }
        }
        return parseFloat(win);
    }

    /**
     * calculate Risk from stake
     * @param {*} stake 
     * @param {*} odds 
     * @param {*} ot : odds type
     * @param {*} wrs : win risk stake (WIN, RISK, BASE)
     */
    static calculateToRisk(stake, odds, ot, wrs){
        let risk = 0;
        if (wrs === 'WIN'){
            risk = this.calculateToRiskFromWin(stake, odds, ot);
        } else if (wrs === 'RISK'){
            risk = stake;
        } else {
            if (odds > 0){
                risk = stake;
            } else {
                risk = this.calculateToRiskFromWin(stake, odds, ot);
            }
        }
        return parseFloat(risk);
    }

    /**
     * Calculate Win from Risk
     * @param {*} riskAmount 
     * @param {*} odds 
     * @param {*} ot : odds type
     */
    static calculateToWinFromRisk(riskAmount, odds, ot){
        let win = 0;
        switch(ot) {
            case OddsFormat.American:
                if (odds === 0){
                    win = 0;
                } else if (odds > 0) {
                    win = (riskAmount / 100) * odds;
                } else if (odds < 0) {
                    win =  (riskAmount / Math.abs(odds)) * 100;
                }
                break;
            case OddsFormat.Decimal:
                win = riskAmount * (odds - 1);
                break;
            case OddsFormat.HongKong:
                win = riskAmount * odds;
                break;
            case OddsFormat.Indonesian:
                win = odds === 0 ? 0 : odds > 0 ? 
                riskAmount * odds : riskAmount / Math.abs(odds);
                break;
            case OddsFormat.Malay:
                win = odds === 0 ? 0 : odds > 0 ? 
                riskAmount * odds : riskAmount / Math.abs(odds);
                break;
            default: win = 0;
        }
        return win;
    }

    /**
     * Calculate Risk from Win
     * @param {*} winAmount 
     * @param {*} odds 
     * @param {*} ot : odds type
     */
    static calculateToRiskFromWin(winAmount, odds, ot){
        let risk = 0;
        switch(ot){
            case OddsFormat.American:
                if (odds === 0){
                    risk = 0;
                } else if (odds > 0) {
                    risk = (winAmount / odds) * 100;
                } else if (odds < 0) {
                    risk = (winAmount / 100) * Math.abs(odds);
                }
                break;
            case OddsFormat.Decimal:
                risk = winAmount / (odds - 1);
                break;
            case OddsFormat.HongKong:
                risk = winAmount / odds;
                break;
            case OddsFormat.Indonesian:
                risk = odds === 0 ? 0 : odds > 0 ? 
                winAmount / odds : winAmount * Math.abs(odds);
                break;
            case OddsFormat.Malay:
                risk = odds === 0 ? 0 : odds > 0 ? 
                winAmount / odds : winAmount * Math.abs(odds);
                break;
            default: risk = 0;
        }
        return risk;
    }

    /**
     * to convert odds format Sport book to Virtual sport
     * @param {*} oddsFormat 
     */
    static convertToOddsFormatVS(oddsFormat){
        switch(oddsFormat){
            case OddsFormat.American:
                return OddsFormatVS.American
            case OddsFormat.Decimal:
                return OddsFormatVS.Decimal
            case OddsFormat.HongKong:
                return OddsFormatVS.HongKong
            case OddsFormat.Indonesian:
                return OddsFormatVS.Indonesian
            case OddsFormat.Malay:
                return OddsFormatVS.Malay
            default:
                return OddsFormatVS.Decimal;
        }
    }

    static singleFocusStake (numberOfBets) {
        let stakeEl = numberOfBets === 1 ? 
                      document.querySelector("#betslip .normal input.stake") :
                      document.querySelector("#betslip input.stakeperbet");
        if (stakeEl) {
            stakeEl.select();
            stakeEl.focus({preventScroll:true});
        }
      }

    static formatStake(nextStake, prevStake){
        let stake;
        if (isNaN(nextStake) || nextStake == 0 ){
            stake =  prevStake !== '' && prevStake !== undefined ? 
            this.convertStakeToNumber(prevStake).toDollar(2, true) : '';
        } else {
            stake = this.convertStakeToNumber(nextStake).toDollar(2, true);
        }
        return stake;
    }

    static convertStakeToNumber(stake){
        if (stake){
            stake = stake.toString().split(',').join('');
        }
        return !isNaN(stake) ? Number(stake) : stake;
    }

    static isExistSelection(oddsId, selections) {
        for (let id in selections) {
            if (id === oddsId) {
                return true;
            }
        }
        return false;
    }

    static getBetTypeName(betType){
        switch(betType){
            case THE_1X2: 
                return 'Moneyline';
            case HANDICAP: 
                return 'HANDICAP';
            case OU:
                return 'Total';
            default:
                return 'TEAM_TOTAL';
        }

    }

    static singleGetOddsRequest(selections, oddsSelection, oddsFormat){
        let selectionsData = this.selectionDataUpdate(selections, oddsSelection, oddsFormat);
        let newSelection = {
            selectionId : oddsSelection.lineId + "|" + oddsSelection.oddsId + "|" + oddsSelection.teamType,
            oddsFormat : oddsFormat,
            oddsId :oddsSelection.oddsId,
            oddsSelectionsType: oddsSelection.oddsSelectionsType
        };
        selectionsData.push(newSelection);
        return selectionsData;
    }

    static buildSelectionRequest(selections, oddsFormat, oddsSelectionsType){
        let selectionsData = [];
        _.forEach(selections, selection =>{
            let selectionDataUpdate = {
                selectionId : selection.lineId + '|' + 
                            selection.oddsId + '|' + selection.teamType,
                oddsFormat : oddsFormat,
                oddsId : selection.oddsId,
                oddsSelectionsType: oddsSelectionsType
            };
            selectionsData.push(selectionDataUpdate);
        });
        return {oddsSelections: selectionsData}
    }

    static selectionDataUpdate(selections, oddsSelection, oddsFormat) {
        let selectionsData = [];
        _.map(selections, selection =>{
            if (selection.oddsId !== oddsSelection.oddsId){
                let selectionDataUpdate = {
                    selectionId : selection.selectionId,
                    oddsFormat : oddsFormat,
                    oddsId : selection.oddsId,
                    oddsSelectionsType: selection.oddsSelectionsType
                };
                selectionsData.push(selectionDataUpdate);
            }
        });
        return selectionsData;
    }

    /**
     * API to call get normal odds of betslip
     * @param {*} selectionData 
     */
    static async singleUpdateOdds(selectionData){
        return await BetServices.updateOddsSelectionsInfo(selectionData)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        });
    }

    /**
     * API to call get normal odds of betslip
     * @param {*} selectionData 
     */
    static async singleGetOdds(selectionData){
        return await BetServices.getOddsSelectionsInfo(selectionData)

            .then(response => {
                return response;

            })
            .catch(error => {
                return error;
            });
    }

    /**
     * API to call get normal odds of betslip
     * @param {*} selectionData 
     */
    static async singleAllGetOdds(selectionData){
        return await BetServices.getAllOddsSelectionsInfo(selectionData)

            .then(response => {
                return response;

            })
            .catch(error => {
                return error;
            });
    }

    /**
     * API to call get parlay odds of betslip
     * @param {*} selectionData 
     */
    static async getParlayOdds(selectionData){
        return await BetServices.parlayOddsSelections(selectionData)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    }

    /**
     * API to call get parlay update odds of betslip
     * @param {*} selectionData 
     */
    static async getParlayUpdateOdds(selectionData){
        return await BetServices.parlayUpdateOdds(selectionData)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    }

    /**
     * API to call place Bets
     * @param {*} selectionData 
     */
    static async placeBet(selectionData){
        let uniqueRequestId = CommonUtil.generateUUID();
        return await BetServices.postPlaceBetAPI(selectionData, uniqueRequestId)
            .then(response => {
                return response;
            });
    }

    /**
     * Make the request data for update odds to call api
     * @param {*} oddsFormat 
     * @param {*} selections : data selections in store
     */
    static updateOddsRequestData(oddsFormat, selections) {
        let selectionsData = [];
        _.forEach(selections, (selection) =>{
            if (!selection.wagerId && 
                (!selection.errorCode  ||  selection.errorCode === 'LINE_CHANGED') &&
                 selection.status !== 'UNAVAILABLE'){
                let selectionDataUpdate = {
                selectionId: selection.selectionId,
                oddsFormat: oddsFormat,
                oddsId: selection.oddsId,
                oddsSelectionsType: selection.oddsSelectionsType
                }
                selectionsData.push(selectionDataUpdate);
            }
        });
        return selectionsData;
    }

    /**
     * Make the request data before paceBets
     * @param {*} selectionsWager : slections in store include outright, normal
     */
    static placeBetsRequestData(selections) {
        let selectionsData = [];
        let requestData = {};
        let oddsFormat;
        let acceptBetterOdds;
        for (let oddsId in selections){
            const selection = selections[oddsId];
            if (!selection.wagerId && (!selection.errorCode  ||  
                selection.errorCode === 'LINE_CHANGED' || selection.errorCode === 'MAX_BET_EXCEEDED') 
                && selection.status !== 'UNAVAILABLE'){
                let selectionDataBet = {
                    stake : this.convertStakeToNumber(selection.stake),
                    selectionId : selection.selectionId,
                    odds : selection.odds,
                    wagerType : selection.oddsSelectionsType,
                    oddsId: selection.oddsId,
                    winRiskStake: selection.winRiskStake
                }
                oddsFormat = (!oddsFormat) ? selection.oddsFormat : oddsFormat;
                acceptBetterOdds = (!acceptBetterOdds) ? selection.acceptBetterOdds : acceptBetterOdds;
    
                let uuid = CommonUtil.generateUUID();
                selectionDataBet.uniqueRequestId = uuid;
                selection.uniqueRequestId = uuid;
                if (selection.pitcher1MustStart) {
                    selectionDataBet.pitcher1MustStart = selection.pitcher1MustStart;
                }
                if (selection.pitcher2MustStart) {
                    selectionDataBet.pitcher2MustStart = selection.pitcher2MustStart;
                }
                if (selection.oddsFormat === OddsFormat.American) {
                    selectionDataBet.winRiskStake = selection.winRiskStake;
                }
                selectionsData.push(selectionDataBet);
            }
        }
        if (selectionsData.length > 0){
            requestData.oddsFormat = oddsFormat;
            requestData.acceptBetterOdds = acceptBetterOdds;
            requestData.selections = selectionsData;
            return requestData;
        } 
    }

    /**
     * Update data from API when refresh odds to selections in store
     * @param {*} oddsFormat 
     * @param {*} selection 
     * @param {*} updatedSelection 
     */
    static updateSelection(oddsFormat, selection, updatedSelection){
        if (!selection){
            return;
        }
        if (oddsFormat === OddsFormat.American){
            let winRiskStake = selection.winRiskStake;
            if (!winRiskStake){
                winRiskStake = 'BASE';
                updatedSelection.winRiskStake = winRiskStake;
            }
            if (!selection.minStake && !selection.maxStake){
                updatedSelection.minStake = updatedSelection.minStakeBase;
                updatedSelection.maxStake = updatedSelection.maxStakeBase;
            } else {
                if (winRiskStake === "WIN"){
                    updatedSelection.minStake = updatedSelection.minStakeWin;
                    updatedSelection.maxStake = updatedSelection.maxStakeWin;
                } else if (winRiskStake === "RISK"){
                    updatedSelection.minStake = updatedSelection.minStakeRisk;
                    updatedSelection.maxStake = updatedSelection.maxStakeRisk;
                } else {
                    updatedSelection.minStake = updatedSelection.minStakeBase;
                    updatedSelection.maxStake = updatedSelection.maxStakeBase;
                }
            }
        }

        BetslipAction.updatePitcher(updatedSelection);
        selection = _.assign(selection, updatedSelection);
        return selection;
    }

    /**
     * To check the status of bet selection
     * @param {*} status 
     */
    static isInValidStatus (status) {
        switch(status){
            case Constants.UNAVAILABLE:
            case Constants.INVALID_BET_ACCEPTANCE_TYPE:
                return true;
            default: return false;
        }
    }

    static getKeyMessage (status) {
        switch(status){
            case Constants.UNAVAILABLE:
                return Constants.UNAVAILABLE_MESSAGE;
            case Constants.INVALID_BET_ACCEPTANCE_TYPE:
                return Constants.INVALID_BET_ACCEPTANCE_TYPE;
            default: return '';
        }
    }

    /**
     * Update data from API when refresh odds to selections in store
     * @param {*} selection 
     * @param {*} updatedSelection 
     */
    static updateClassicSelection(selection, updatedSelection){
        if (!selection){
            return;
        }
        let winRiskStake = selection.winRiskStake;
        if (!winRiskStake){
            winRiskStake = 'BASE';
            updatedSelection.winRiskStake = winRiskStake;
        }
        if (winRiskStake === "WIN"){
            updatedSelection.minStake = updatedSelection.minStakeWin;
            updatedSelection.maxStake = updatedSelection.maxStakeWin;
        } else if (winRiskStake === "RISK"){
            updatedSelection.minStake = updatedSelection.minStakeRisk;
            updatedSelection.maxStake = updatedSelection.maxStakeRisk;
        } else {
            updatedSelection.minStake = updatedSelection.minStakeBase;
            updatedSelection.maxStake = updatedSelection.maxStakeBase;
        }
        BetslipAction.updatePitcher(updatedSelection);
        selection = _.assign(selection, updatedSelection);
        if (_.isNil(selection.odds)){
            selection.odds = 0;
          }
        return selection;
    }

    static updateStakeChanged(oddsId, stakeValue) {
        const listElement = this.getAllStakeEntered();
        $.each(listElement, function(idx, item) {
            let parentEle = item.parentElement;
            let id;
            if (parentEle.getElementsByClassName('custom-dropdown').length === 0) {
                id = parentEle.getAttribute('id');
            } else {
                id = $(parentEle).find('.custom-dropdown-menu li.selected')[0].getAttribute('id');
            }

            if (id === oddsId){
                item.setAttribute('value', stakeValue);
                item.value = stakeValue;
            }
        });
    }

    /**
     * Get all elements which has inputed stake to clear
     */
    static getAllStakeEntered() {
        return $(document.getElementById('classic-line')).find("input.stake[value!='']");
    }

    static getTeaserTicket = async (ticketId, teaserId, oddsFormat, legs) => {
      const teaserTicketParams = {
        ticketId: ticketId,
        teaserId: teaserId,
        oddsFormat: oddsFormat,
        legs: JSON.stringify(legs),
      };

      const teaserTicket = await memberService.getTeaserTicketAPI(teaserTicketParams).then(res => {
        if (res.status >= 400) {
          return {};
        }
        return res.data;
      }).catch(e => {
        throw e;
      });

      return teaserTicket;
    }

    static removeTeaserTicket = async (ticketId, teaserId, oddsFormat, legId) => {
      const teaserTicketParams = {
        ticketId: ticketId,
        teaserId: teaserId,
        oddsFormat: oddsFormat,
        legId: legId,
      };

      const teaserTicket = await memberService.removeTeaserTicketAPI(teaserTicketParams).then(res => {
        if (res.status >= 400) {
          return {};
        }
        return res.data;
      }).catch(e => {
        throw e;
      });

      return teaserTicket;
    }

    static updateWinRiskStakeToAmericanOdds(teaserTicket) {
      const { odds, minRiskStake, maxRiskStake, minWinStake, maxWinStake } = teaserTicket;
      let { winRiskStake } = teaserTicket;

      if (!winRiskStake) {
        winRiskStake = 'BASE';
      }
      let minStake = 0;
      let maxStake = 0;

      if (winRiskStake === 'WIN'){
        minStake = minWinStake;
        maxStake = maxWinStake;
      } else if (winRiskStake === 'RISK') {
        minStake = minRiskStake;
        maxStake = maxRiskStake;
      } else {
        if (odds) {
          if (odds > 0) {
            minStake = minRiskStake;
            maxStake = maxRiskStake;
          } else {
            minStake = minWinStake;
            maxStake = maxWinStake;
          }
        }
      }
      teaserTicket.minStake = minStake;
      teaserTicket.maxStake = maxStake;
      teaserTicket.winRiskStake = winRiskStake;
    }

    static updateWinRiskStakeToRemainingOdds(teaserTicket) {
      const { odds, minRiskStake, maxRiskStake, minWinStake, maxWinStake } = teaserTicket;
      if (odds) {
        if (odds > 0) {
          teaserTicket.minStake = minRiskStake;
          teaserTicket.maxStake = maxRiskStake;
          teaserTicket.winRiskStake = "RISK";
        } else {
          teaserTicket.minStake = minWinStake;
          teaserTicket.maxStake = maxWinStake;
          teaserTicket.winRiskStake = "WIN";
        }
      } else {
        teaserTicket.minStake = 0;
        teaserTicket.maxStake = 0;
      }
    }

    static updateTeaserTicket = (teaserTicket, oddsFormat, currentStake) => {
      if (oddsFormat === OddsFormat.American){
        BetslipAction.updateWinRiskStakeToAmericanOdds(teaserTicket);
      } else {
        BetslipAction.updateWinRiskStakeToRemainingOdds(teaserTicket);
      }

      if (currentStake) {
        teaserTicket.stake = currentStake;
      } else {
        delete teaserTicket.stake;
      }
    }

    static updateClassicTeaserTicket = (teaserTicket) => {
        BetslipAction.updateWinRiskStakeToRemainingOdds(teaserTicket);
    }

    static updateParlayTicket = (parlayTicket, currentStake) => {
        parlayTicket.winRiskStake = 'RISK';
        if (currentStake) {
            parlayTicket.stake = currentStake;
        } 
      }

    static isValidLegs(teaserSelectionsSize, teaserTicket) {
      if (!_.isEmpty(teaserTicket) && teaserSelectionsSize >= teaserTicket.maxLegs) {
        return false;
      }
      return true;
    }

    static async placeTeaserBet(selectionData, uniqueRequestId) {
      return await BetServices.placeTeaserBetAPI(selectionData, uniqueRequestId).then(response => {
        return _.get(response, 'data', {});
      }).catch(error => {
        return error;
      });
    }

    static updateTeaserSelections(teaserSelections, teaserTicket) {
      let hasSelectionError = false;
      if (!teaserTicket.legs) {
        return hasSelectionError;
      }

      _.forEach(teaserSelections, selection => {
        _.forEach(teaserTicket.legs, leg => {
          if (selection.legId === leg.legId) {
            Object.assign(selection, leg);
            const { errorCode } = selection;
            if (errorCode){
                if ('POINTS_NO_LONGER_AVAILABLE' === errorCode ||'EVENT_NOT_FOUND' === errorCode){
                    selection.errorMessage = 'Selection currently is unavailable.';
                }
                hasSelectionError = true;
            } else {
                selection.errorMessage = null;
            }
            return false;
          }
        });
      });
      return hasSelectionError;
    }

    static removeClassicParlaySelection = async (selectionsData, legId) =>{
        return await BetServices.parlayRemoveSelection(selectionsData, legId).then(res =>{
            if (res.status >= 400) {
                return {};
            }
            return res.data;
        })
    }

    static placeParlayBet = async (selections, uniqueRequestId) =>{
        return await BetServices.placeParlayBet(selections, uniqueRequestId).then(res =>{
            return res;
        })
    }

    static updatePitcherParlay = async (params) => {
        return await BetServices.updatePitcherParlay(params).then(res => {
            if (res.status >= 400) {
                return {};
            }
            return res.data;
        });
    }

    /**
    * Build parlay request params.
    */
    static buildParlayOddsSelectionsRequest(oddsFormat, parlayTicketId, parlaySelectedOdds) {
        let arrOdds = [];

        _.map(parlaySelectedOdds, function (item, idx) {
            arrOdds.push({
                legId: item.legId,
                selectionId: item.lineId + '|' + item.oddsId + '|' + item.teamType
            });
        })
        return ({
            parlayOddsRequest: {
                ticketId: parlayTicketId,
                oddsFormat: oddsFormat,
                parlayOddsSelections: arrOdds
            }
        });
    }

    /**
    * Build parlay request params.
    */
   static buildParlayOddsUpdateRequest(oddsFormat, parlayTicketId, parlaySelectionsOdds) {
    let arrOdds = [];

    _.map(parlaySelectionsOdds, function (item, idx) {
        arrOdds.push({
            legId: item.legId,
            selectionId: item.selectionId
        });
    })
    return ({
        parlayOddsRequest: {
            ticketId: parlayTicketId,
            oddsFormat: oddsFormat,
            parlayOddsSelections: arrOdds
        }
    });
}

    static updateParlayOddsSlectionsResponse(oddsFormat, parlaySelectedOdds, legs) {
        let hasParlaySelectionError = false;
        _.map(parlaySelectedOdds, function (selectionInput, idx) {
            _.map(legs, function (leg, idx) {
                if (leg.legId === selectionInput.legId) {
                    leg.oddsFormat = oddsFormat;
                    Object.assign(selectionInput, leg);
                    if (selectionInput.errorCode){
                        hasParlaySelectionError = true;
                    }
                    BetslipAction.updatePitcher(selectionInput);
                    if (selectionInput.legStatus === Constants.UNAVAILABLE) {
                        selectionInput.errorMessage = this.props.t("errors:" + Constants.UNAVAILABLE_MESSAGE);
                    }
                }
            })
        });
        return hasParlaySelectionError;
    }

    static updateClazzicParlaySelections(oddsFormat, parlaySelections, legs, translate, errorMsg) {
        let parlayErrorMessage;
        let isOddsChanged = false;
        _.map(parlaySelections, function (selection, idx) {
            _.map(legs, function (leg, idx) {
                if (leg.legId === selection.legId) {
                    leg.oddsFormat = oddsFormat;
                    if (selection.errorCode === 'LINE_CHANGED'){
                        leg.errorCode = selection.errorCode;
                        parlayErrorMessage = selection.errorCode;
                    }
                    if (leg.legStatus === 'ODDS_CHANGE' && 
                            Number(leg.odds) !== Number(selection.odds)) {
                        leg.errorMessage = translate("ODDS_CHANGED_MESSAGE").replace('{0}', 
                        BetslipAction.formatOddsChange(selection.odds, oddsFormat)).replace('{1}', 
                        BetslipAction.formatOddsChange(leg.odds, oddsFormat));
                        isOddsChanged = true;
                    } 
                    else {
                        leg.errorMessage = '';
                    }
                    Object.assign(selection, leg);
                    
                    BetslipAction.updatePitcher(selection);
                    if (selection.legStatus === Constants.UNAVAILABLE) {
                        selection.errorMessage = translate("errors:" + Constants.UNAVAILABLE_MESSAGE);
                    }
                }
            })
        });
        if (isOddsChanged){
            parlayErrorMessage = errorMsg;
        }
        return parlayErrorMessage;
    }

    static formatOddsChange (odds, oddsFormat){
        var isAmPositiveOdds = oddsFormat === OddsFormat.American && odds > 0
        const formatOdds = oddsFormat === OddsFormat.AM ? Number(odds) : Number(odds).toDollar(3, true);
        return (isAmPositiveOdds ? '+' : '') + formatOdds;
    }

    static updatePitcher(selectionInput){
        if (selectionInput.sportId === Constants.BASEBALL_ID && selectionInput.eventTeamType === 1){
            if (selectionInput.pitcherHome){
                selectionInput.pitcher2MustStart = true;
            }
            if (selectionInput.pitcherAway){
                selectionInput.pitcher1MustStart = true;
            }
        } else {
            if (selectionInput.pitcherHome){
                selectionInput.pitcher1MustStart = true;
            }
            if (selectionInput.pitcherAway){
                selectionInput.pitcher2MustStart = true;
            }
        }
    }

    /**
      * Start Round Robin Calculation
      */

    /**
     * Calculate Parlay Max payout
     */
    static calculateParlayMaxPayout(stake, availableRROs, selectedRROs, oddsFormat, isVirtualSport) {
        let winriskInfo = { toWin: 0, totalStake: 0, maxPayout: 0 }

        if (!stake || stake === 0 || _.isEmpty(availableRROs) || (availableRROs.length > 1 && _.isEmpty(selectedRROs))) {
            return winriskInfo
        }

        if (_.isEmpty(selectedRROs) && availableRROs.length === 1){
            selectedRROs = ['Parlay'];
        }

        let convertedOddsFormat = isVirtualSport ? OddsFormat[oddsFormat] : oddsFormat
        // Loop through the available RROs and calculate
        _.forEach(availableRROs, roundRobin => {
            if (selectedRROs.indexOf(roundRobin.roundRobinOption) > -1) {
                let roundRobinOdds;
                let totalStake;
                let totalToWin;

                if (roundRobin.roundRobinOption === RoundRobinOption.PARLAY) {
                    totalStake = stake;
                    totalToWin = this.calculateToWinFromRisk(stake, roundRobin.odds, convertedOddsFormat);

                } else {
                    roundRobinOdds = roundRobin.unroundedDecimalOdds;
                    totalToWin = stake * (roundRobinOdds - 1);
                    totalStake = stake * roundRobin.possibleWagers;
                }
                winriskInfo.toWin += totalToWin;
                winriskInfo.totalStake += totalStake;
                winriskInfo.maxPayout += totalToWin + totalStake;
            }
        })

        return winriskInfo
    }

    /**
     * Calculate Parlay Payout
     */
    static calculateParlayPayout(parlayOdds, stake, oddsFormat) {
        if (!stake) {
            return 0;
        }
        return this.calculateToWinFromRisk(stake, parlayOdds, oddsFormat) + stake;
    }

    static calculateParlayPayoutByRRO(winriskInfo, roundRobin, stake) {

        let totalToWin = stake * (roundRobin.unroundedDecimalOdds - 1);
        let totalStake = stake * roundRobin.possibleWagers;

        //update results
        winriskInfo.toWin += totalToWin;
        winriskInfo.totalStake += totalStake;
        winriskInfo.maxPayout += totalToWin + totalStake

        return winriskInfo;
    }

    /** End Virtual Sports */

    /**
     * API to call pending bet
     * @param {*} selectionData 
     */
    static async getMyBets() {
      return await BetServices.getMyBets().then(res => {
        return res.data;
      })
      .catch(e => {
        return null;
      });
    }
    
    static isExistingProcessingBets(selections) {
      const processingBets = Object.keys(selections)
        .filter(key => selections[key].acceptMessage && selections[key].acceptMessage === Constants.BET_ACTIONS.BET_PROCESSING)
        .reduce((arr, key) => {
            arr.push(selections[key]);
            return arr;
      }, []);
    
      
      return processingBets.length > 0;
    }

    static calculateTeaserWinRiskInfo(stake, odds, oddsFormat, winRiskOption){
        let winriskInfo = { toWin: 0, toRisk: 0}
    
        if (!stake || stake === 0) {
          return winriskInfo
        }
        let oddsValue = parseFloat(odds);
        let convertedStake = BetslipAction.convertStakeToNumber(stake);
        if (OddsFormat.American === oddsFormat) {
          switch (winRiskOption){
              case 'WIN': 
                  winriskInfo.toWin = convertedStake;
                  winriskInfo.toRisk = BetslipAction.calculateToRiskFromWin(convertedStake, oddsValue, oddsFormat);
                  break;
              case 'RISK': 
                  winriskInfo.toRisk = convertedStake;
                  winriskInfo.toWin = BetslipAction.calculateToWinFromRisk(convertedStake, oddsValue, oddsFormat);
                  break;
              default: BetslipAction.calculateNormalOdds (convertedStake, oddsValue, oddsFormat, winriskInfo);
                  
          }
        } else {
          BetslipAction.calculateNormalOdds(convertedStake, oddsValue, oddsFormat, winriskInfo);
        }
        return winriskInfo;
      }

      static calculateNormalOdds (stake, odds, oddsFormat, winriskInfo){
        let isOddsNegative = odds < 0;
        switch (isOddsNegative){
            case true :
                winriskInfo.toWin = stake;
                winriskInfo.toRisk = BetslipAction.calculateToRiskFromWin(stake, odds, oddsFormat);
                break;
            default :
                winriskInfo.toRisk = stake;
                winriskInfo.toWin = BetslipAction.calculateToWinFromRisk(stake, odds, oddsFormat);
        }
      }

      static submitHorseRacingPlaceBets = (data, token, isEnableRBDomainConfig, hrDomainName) => {
        return isEnableRBDomainConfig && hrDomainName ? BetServices.submitHorseRacingPlaceBetsConfig(hrDomainName, data, token)
          : BetServices.submitRbPlaceBetsSameDomain(data, token);
      }

}


// WEBPACK FOOTER //
// ./src/app/actions/BetslipAction.js